import { HeroId } from "../../../../shared/src/index.ts";
import type { VoiceScript } from "../voice-types.ts";

const script = {
  hero: HeroId.SubMarinara,
  voices: {
    main: {
      description:
        "booming coastal king bass, briny theatrical swagger, rolling Mediterranean-flavored vowels, wet cave resonance, imperious but oddly culinary warmth",
      seed: 10577,
      guidance: 0.76,
      loudness: 0.78,
    },
  },
  lines: {
    select: [
      {
        id: "select_1",
        text: "Those who oppose me shall be left to drown in my wake.",
      },
      { id: "select_2", text: "Sub-Marinara has arrived." },
      { id: "select_3", text: "Make way for King Sub-Marinara." },
      { id: "select_4", text: "Sub-Marinara shall bide his time… for now.." },
    ],
    spawn: [
      {
        id: "spawn_1",
        text: "Splendid! Even more of my loyal subjects answer my call!",
      },
      {
        id: "spawn_2",
        text: "Together, Hulk, we shall rule the sea and the land!",
      },
      {
        id: "spawn_3",
        text: "These air breathers cannot withstand the cold from below…",
      },
      {
        id: "spawn_4",
        text: "Our foes shall perish in a flood of salt and snow!",
      },
      {
        id: "spawn_5",
        text: "My war against the surface world will have to wait… for now…",
      },
      {
        id: "spawn_6",
        text: "You surface dwellers can't resist destroying yourselves, can you?",
      },
      {
        id: "spawn_7",
        text: "Ah, I had wondered when Doom would finally bring about the end of all things…",
      },
      {
        id: "spawn_8",
        text: "I am beginning to think I should have stayed beneath the waves…",
      },
      {
        id: "spawn_9",
        text: "Ah...I've met pods of dolphins more capable of saving the world…",
      },
      { id: "spawn_10", text: "My kingdom shall rise as swiftly as the seas." },
      { id: "spawn_11", text: "The tides always turn in my favor." },
      {
        id: "spawn_12",
        text: "We have hidden in the depths long enough. Now is the time to strike!",
      },
      {
        id: "spawn_13",
        text: "Three quarters of the Earth is mine to rule. I have come to claim the rest.",
      },
      {
        id: "spawn_14",
        text: "I am the ocean's avenging son. You will get no love from me.",
      },
      {
        id: "spawn_15",
        text: "Just like the pressure of the ocean, I shall crush our foes.",
      },
      {
        id: "spawn_16",
        text: "You are in the presence of royalty. It would be wise to show some respect.",
      },
    ],
    respawn: [
      {
        id: "respawn_1",
        text: "Like the tide, Sub-Marinara always rises again.",
      },
      { id: "respawn_2", text: "I will not be stopped so easily." },
      { id: "respawn_3", text: "My battle has only just begun." },
      { id: "respawn_4", text: "You cannot wash your hands of Sub-Marinara." },
    ],
    ult_ally: [{ id: "ult_ally", text: "Leviathan, crown them below!" }],
    ult_enemy: [{ id: "ult_enemy", text: "The deep claims you!" }],
    secondary: [
      { id: "secondary_1", text: "Wash our foes away!" },
      { id: "secondary_2", text: "Drown them!" },
      { id: "secondary_3", text: "Cleanse this place!" },
    ],
    ability2: [
      { id: "ability2_1", text: "Denizens of the deep!" },
      { id: "ability2_2", text: "Attack them!" },
      { id: "ability2_3", text: "Protect your king!" },
    ],
    ability1: [
      { id: "ability1_1", text: "Oceans, protect me!" },
      { id: "ability1_2", text: "I summon the seas!" },
      { id: "ability1_3", text: "These waves will not break!" },
    ],
    kill: [
      { id: "kill_1", text: "Ha! You never had a chance." },
      { id: "kill_2", text: "Typical air breather." },
      { id: "kill_3", text: "Just as expected…" },
      { id: "kill_4", text: "Consider yourself conquered." },
      { id: "kill_5", text: "Sub-Marinara does not lose." },
    ],
    multikill: [
      { id: "multikill_1", text: "Three of them down." },
      { id: "multikill_2", text: "Impressive, as always." },
      { id: "multikill_3", text: "They all drown in my wake." },
      { id: "multikill_4", text: "All shall fall at my hand!" },
      { id: "multikill_5", text: "I cannot be stopped." },
      { id: "multikill_6", text: "Five already?" },
      { id: "multikill_7", text: "Victory is mine!" },
      { id: "multikill_8", text: "Sub-Marinara stands triumphant!" },
      { id: "multikill_9", text: "Really? Is that all?" },
    ],
    low_hp: [
      { id: "low_hp_1", text: "My strength is returning." },
      { id: "low_hp_2", text: "Back to the fight!" },
    ],
    healed: [
      { id: "healed_1", text: "Ah. How refreshing." },
      { id: "healed_2", text: "That is much better." },
      { id: "healed_3", text: "Healing power? Perfect…" },
      { id: "healed_4", text: "This should help me recover." },
    ],
  },
} satisfies VoiceScript;

export default script;
